__turbopack_context__.v({
  "container": "Container-module-scss-module__6YHjbq__container",
  "fluid": "Container-module-scss-module__6YHjbq__fluid",
  "lg": "Container-module-scss-module__6YHjbq__lg",
  "md": "Container-module-scss-module__6YHjbq__md",
  "sm": "Container-module-scss-module__6YHjbq__sm",
  "xl": "Container-module-scss-module__6YHjbq__xl",
});
